import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Download, Eye, FileText, Presentation, Trash2 } from 'lucide-react';

const formatSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export const CatalogoCard = ({ item, canManage, onView, onDownload, onDelete }) => {
  const isCatalogo = item.category === 'catalogo';
  const Icon = isCatalogo ? FileText : Presentation;
  return (
    <div
      data-testid={`catalogo-card-${item.id}`}
      className="group bg-white border border-slate-200 rounded-lg p-5 flex flex-col gap-3 hover:border-blue-300 hover:shadow-md transition-[border-color,box-shadow]"
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 ${isCatalogo ? 'bg-blue-50 text-blue-700' : 'bg-amber-50 text-amber-700'}`}>
          <Icon className="w-5 h-5" strokeWidth={1.5} />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold text-slate-900 leading-snug break-words" data-testid="catalogo-card-title">{item.title}</h3>
          <Badge className={`mt-1 border-0 text-[10px] ${isCatalogo ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}`}>
            {isCatalogo ? 'Catálogo' : 'Apresentação'}
          </Badge>
        </div>
      </div>
      {item.description && <p className="text-sm text-slate-600 line-clamp-3 break-words">{item.description}</p>}
      <p className="text-xs text-slate-400 mt-auto">
        {new Date(item.created_at).toLocaleDateString('pt-BR')} · {formatSize(item.size)} · {item.created_by}
      </p>
      <div className="flex gap-2">
        <Button size="sm" className="flex-1" onClick={() => onView(item)} data-testid={`catalogo-view-${item.id}`}>
          <Eye className="w-4 h-4 mr-1.5" />Visualizar
        </Button>
        <Button size="sm" variant="outline" onClick={() => onDownload(item)} data-testid={`catalogo-download-${item.id}`}>
          <Download className="w-4 h-4" />
        </Button>
        {canManage && (
          <Button size="sm" variant="outline" className="text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={() => onDelete(item)} data-testid={`catalogo-delete-${item.id}`}>
            <Trash2 className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
